import PropTypes from 'prop-types'
import React from 'react'
import styles from 'components/migration/_migrate.css'

export default function migrateRequestSent (props) {
  const email = props.email
  return (
    <div>
      <h2 className={styles.title}>
        转移请求已发送
      </h2>
      <p className={styles.migrateParagraph}>
        关于将您的UA MapMyRun锻炼数据转移至UA Run的操作链接，已发送至{email}。
        <br /><br />几分钟后，若您仍未收到我们的电子邮件，请确保您输入的登录信息准确无误，
        并查看您的垃圾邮件文件夹。<br /><br />如需更多帮助，
        <a href='http://support.mapmyfitness.com'>请联系我们的支持团队</a>。
      </p>
    </div>
  )
}

migrateRequestSent.propTypes = {
  email: PropTypes.string,
}
